const validateForm = values => {
  let errors = {};

  if (!values.street) {
    errors.street = { key: 'mixed.required' };
  }

  if (!values.building) {
    errors.building = { key: 'mixed.required' };
  }

  return errors;
};

export default validateForm;
